import BootstrapVue from 'bootstrap-vue'
import Murmur from '@icij/murmur'
import Vue from 'vue'
import VueAnalytics from 'vue-analytics'
import VueRouter from 'vue-router'
import VueScrollactive from 'vue-scrollactive'
import VueScrollTo from 'vue-scrollto'
import { library as fortawesome } from '@fortawesome/fontawesome-svg-core'
import { faExternalLinkAlt, faTimes } from '@fortawesome/free-solid-svg-icons'

import { routes } from './router'

import './main.scss'

Vue.config.productionTip = false
Murmur.config.set('project.name', 'FinCEN Files')
Murmur.config.set('app.name', 'Charts')
Murmur.config.set('sharing-options.title', 'FinCEN Files')
Murmur.config.set('sharing-options.url', 'https://www.icij.org/investigations/fincen-files/')

fortawesome.add(faExternalLinkAlt)
fortawesome.add(faTimes)

Vue.use(BootstrapVue)
Vue.use(Murmur)
Vue.use(VueAnalytics, { id: 'UA-3383794-15' })
Vue.use(VueRouter)
Vue.use(VueScrollactive)
Vue.use(VueScrollTo)

const router = new VueRouter({ routes })
const render = h => h('div', { attrs: { id: 'app' } }, [
  h('RouterView', { props: { name: 'header' } }),
  h('RouterView'),
  h('RouterView', { props: { name: 'footer' } })
])
// Create a mount the main Vue instance
new Vue({ router, render }).$mount('#app')
